import React from 'react';
import PageTemplate from '../PageTemplate';

const History = () => {
  return (
    <PageTemplate
      title="📋 창립 경과보고"
      description="청소년 스마트폰 프리 운동본부 창립 경과보고"
    >
      <div style={{ padding: '1rem' }}>
          <div style={{
          textAlign: 'right', 
          marginBottom: '2rem',
          fontSize: '1rem',
          color: '#666'
        }}>
          2025.6.17.
        </div>

        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '150px 1fr',
          gap: '0'
        }}>
          {/* 헤더 */}
          <div style={{ 
            background: '#f8f9fa', 
            padding: '0.8rem', 
            fontWeight: 'bold',
            textAlign: 'center'
          }}>날짜 또는 기간</div>
          <div style={{ 
            background: '#f8f9fa', 
            padding: '0.8rem',
            fontWeight: 'bold',
            textAlign: 'center'
          }}>내용</div>

          {/* 데이터 행들 */}
          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-02-03</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>7인의 교육 관련 정책연구 모임 시작</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-02-07</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>미국 교육 정책, 인성, 교육장 인사제도 문제 및 개선 대책 연구 시작</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-03-01</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>고1 아이에게 첫 스마트폰' 오마이뉴스 기사 계기로 교육현장 문제 관심 집중, 7인 연구 스터디 시작</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-03-12</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>장준호 교수, 아시아경제·미주중앙일보 기고 통해 스마트폰 중독과 'wait until 8th' 캠페인 소개</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-03-13</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>'wait until 8th' 관련 본격적 연구 및 스터디 가동</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-03-18</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>학생 핸드폰 사용 규제에 관한 현장 의견 중심 문제점 고찰</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-03-20</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>스마트폰 프리 운동 예비모임 (전현직 교사 및 학부모 12인)</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-03-26</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>화성 송린초 학부모 특강(우동희 교장), 교사·학부모 연대움직 제안, 현장규제 캠페인 토론</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-04-02<br/>~04-26</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>Anxious Generation, 원서 위기 및 정보 통신사 학교 학부모의 역할 토론</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-04-08</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>세계 각국의 핸드폰 규제 운동 영상 시청 후 토론의 개최 결의</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-04-09</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>smartphonefreechildhood.co.uk 사례 시청 및 토론</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-04-10</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>캠페인 명칭 '논의 및 운동 기획('중학교까지 스마트폰 제로', 'No Smartphones Before High School' 등), 학부모 의견 청취</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-04-20</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>LA 교육청 phone-free school 시행 사례 조사, 언론 기고, 제목: '중학교까지 기다려요' 게재</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-04-21</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>스마트폰이 여학생에게 더 해롭다는 연구 주제 토의 및 Z세대와 스마트폰 의존의 정치사회적 관계 분석 토론</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-04-22<br/>~04-30</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>교사단체(전교조, 경기교사노조연맹 등)에 운동 설명 및 참여 요청</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-04-25</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>휴대전화 금지 법안 및 해외 정책 사례 토론 (한국, 미국, 호주 등)</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-04-27</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>'Wait Until 8th' 운동 심층 분석, 영국·프랑스 등 국제 정책 비교, 공식 명칭 '중학교까지 기다려요' 제안</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-04-29</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>국가인권위원회 '교내 휴대전화 수거는 인권침해 아냐' 발표문 검토</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-04-30</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>- 운동 단체명 및 조직화 협의<br/>- 안민석 교수, 한계례 기고 "청소년 스마트폰 사용 '중학교까지 기다려요' (에너지)"</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-05-05</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>불안세대, 번역본을 중심으로 phone free 운동의 필요성 토의</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-05-11</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>- 용인 베니따 정원에서 음악회 겸 운동 모임 개최 <br/>- 발대식: 이동현 총장 등 교육계 인사 및 시민 200여 명 참가, '청소년 노(NO) 스마트폰 운동' 선언</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-05-16</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>장준호 교수 아주경제 기고 '청소년 스마트폰 사용의 비극적 아이러니'</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-05-19</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>운동 공식 명칭 '스마트폰 프리운동(스프운동)' 확정, 캐릭터 제작</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-05-22</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>조직 강화, 6.19 출범식 및 초청강연(2025 서울대 전체 수석 김유진 학생 고3까지 스마트폰 없이 공부한 사례) 결의</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-05-29</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>「불안세대」 저자 조너선 하이트 교수 스프운동 출범식 영상 축사 확정</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-05-31</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>파주중 이혁규 교장 다문화가정 학부모 및 아이 대상 강연</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-06-06</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>오산지역본부 발대식(오산천, 50여명 참가)</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#f9f9f9'
          }}>2025-06-11</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#f9f9f9'
          }}>화성 송림이음터 학부모 강연(이건 운영위원장), 스프운동 조직 구성</div>

          <div style={{ 
            padding: '0.8rem', 
            background: '#fff'
          }}>2025-06-14</div>
          <div style={{ 
            padding: '0.8rem',
            background: '#fff'
          }}>청소년 스마트폰 프리 운동본부 정관 재수정 및 고문·자문단 구성</div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default History; 